import React, { Component } from 'react';
import { APP_URL_API } from '../../../setup/configs';
import Input from '../../../ui/input/Input';
import axios from 'axios';
import Header from '../../common/Header';
import Modal from '../../../ui/modal/Modal';
import AuthService from '../../auth/AuthService';
import withAuth from '../../auth/withAuth';

class ManageAdmins extends Component {
	constructor(props) {
        super(props);
        this.state = {
            password: '',
            username: '',
            userDeleted: false,
            dataSaved: false,
            user: {
                "name": "",
                "username": "",
                "email": ""
            },
            users: [],
            showModal: false,
        }
    }
    componentDidMount() {
    	this.fetchData();
    }

    fetchData() {
    	const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'users/type/admin';

        this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                	if(result.data) {
                        this.setState({
                            users: result.data.data
                        })
                	}
                }.bind(this))
    }

	onChange = (e) => {
	    const name= e.target.name;
	    const value= e.target.value;

	    this.setState(prevState => ({
	      user: {
            ...prevState.user,
            [name]: value,
            },
	    }));
	};

    onHandleDeleteUser = (id) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};

        const url = APP_URL_API + 'users/admin/' + id;

        this.serverRequest =
        axios
            .delete(url, {headers: config})
            .then(function(result) {
                this.setState({
                    userDeleted: true,
                }, this.fetchData())
                }.bind(this))
    }

    onHandleResetPassword = (user) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};

        const url = APP_URL_API + 'users/admin/updatePassword/' + user.id;


        const data = {};
        data._method = "patch";

        this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(result) {
                this.setState({
                    password: result.data.data.password,
                    showModal: true,
                    username: user.username,
                })
                }.bind(this))
    }

	onHandleCreateUser = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'users/admin';

        const data = this.state.user;
    
        this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(result) {
                this.setState({
                    dataSaved: true,
                    password: result.data.data.password,
                    showModal: true,
                    username: this.state.user.username,
                    user: {
                        "name": "",
                        "username": "",
                        "email": ""
                    }
                }, this.fetchData())
            }.bind(this))
	}

    onToggleModal = () => {
        if(this.state.showModal) {
            this.setState({
                showModal: false
            });
        } else {
            this.setState({
                showModal: true
            })
        }
    }

    onCreateEmail = () => {
    	const body = "By-, Land- og Kirkeministeriet har nulstillet jeres kodeord til Trossamfundsregistret på http://www.km.dk/andre-trossamfund/" + escape('\r\n\r\n') + "Brugernavn: " + this.state.username + escape('\r\n\r\n') + "Nyt kodeord: " + this.state.password + escape('\r\n\r\n') + "Med venlig hilsen" + escape('\r\n\r\n') + "By-, Land- og Kirkeministeriet";
    	window.location.href = 'mailto:?subject=Nulstilling af kodeord på Trossamfundsregistret&body='+body;
    }

	render() {
		const { users } = this.state;

        return(
			<div>
				<Header user={this.props.user} history={this.props.history}>
	              {this.props.user.type === 'admin' && <nav className="navigation">
	                <ul className="navigation__list">
	                  <li className="navigation__listitem"><a href="/admin/organizations/">Oversigt</a></li>
	                  <li className="navigation__listitem"><a href="/admin/organization/create">Opret</a></li>
	                  <li className="navigation__listitem active"><a href="/admin/organizations/settings">Indstillinger</a></li>
	                </ul>
	              </nav>}
	            </Header>

	            <ul className="navigation__list navigation__list--settings">
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/">Årsoversigt</a></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert/">Tilsynsmeddelelse</a></li>
					<li className="navigation__listitem--small"><a href="/admin/organizations/settings/alert-info/">Informationsmeddelelse</a></li>
	            	<li className="navigation__listitem--small"><a href="/admin/organizations/settings/mail/">Mailafsendelse</a></li>
	            	<li className="navigation__listitem--small"><u>Brugerstyring</u></li>
            	</ul>

	            <div className="content-wrapper">
                    <div style={{margin: '2rem 0', padding: '1rem 0'}}>
		                    <h3 className="list-header" style={{margin: '2rem 0'}}>Opret ny administrator</h3>
                            <div class="flex gap-8" style={{justifyContent: 'space-between'}}>
                                <Input
                                    type="text"
                                    placeholder="* Navn"
                                    name="name"
                                    autoComplete="off"
                                    value={this.state.user.name}
                                    onChange={(e) => this.onChange(e)}
                                />
                                <Input
                                    type="text"
                                    placeholder="* Brugernavn"
                                    name="username"
                                    autoComplete="off"
                                    value={this.state.user.username}
                                    onChange={(e) => this.onChange(e)}
                                />
                                <Input
                                    type="text"
                                    placeholder="* Email"
                                    name="email"
                                    autoComplete="off"
                                    value={this.state.user.email}
                                    onChange={(e) => this.onChange(e)}
                                />
                            </div>
                            <div class="flex" style={{width: '100%', justifyContent: 'flex-end', marginTop: '1.5rem'}}>
                                <button className="button ocean" onClick={this.onHandleCreateUser}>Opret</button>
                            </div>
	                    </div>
	                    <div style={{margin: '2rem 0'}}>
		                    <h3 className="list-header">Admin-brugere</h3>
	                    </div>
                        <table style={{width: '100%'}}>
                            <thead>
                                <tr>
                                    <th align="left">Navn</th>
                                    <th align="left">Brugernavn</th>
                                    <th align="left">E-mail</th>
                                </tr>
                            </thead>
                            <tbody>
                            {users.map(user => (
                                <tr key={user.id}>
                                    <td style={{padding: '.5rem 0'}}>{user.name}</td> 
                                    <td>{user.username}</td> 
                                    <td>{user.email}</td> 
                                    <td align="right" style={{padding: '0 0 0 1rem'}}>
                                        {this.props.user.id !== user.id && <button style={{borderRadius: '100px', border: 'none', padding: '0.25rem .75rem', cursor: 'pointer'}} onClick={() => { if (window.confirm('Er du sikker på at du vil slette brugeren?')) this.onHandleDeleteUser(user.id)}}>Slet</button>}
                                    </td>
                                    <td align="right" style={{padding: '0 0 0 1rem'}}>
                                        <button style={{borderRadius: '100px', border: 'none', padding: '0.25rem .75rem', cursor: 'pointer'}} onClick={() => { if (window.confirm('Er du sikker på at du vil nulstille kodeord?')) this.onHandleResetPassword(user)}}>Nulstil kodeord</button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                        <Modal visible={this.state.showModal}>
                            <h4>Nyt kodeord</h4>
                            <div style={{marginTop: '1em'}}></div>
                            <table><tbody><tr><td>Brugernavn:</td><td>{this.state.username}</td></tr><tr><td>Adgangskode:</td><td>{this.state.password}</td></tr></tbody></table>
                            <div style={{marginTop: '1em'}}>
                                    <button type="button" className="button" onClick={() => this.onToggleModal()}>Luk</button>
                                    <button type="button" className="button" onClick={this.onCreateEmail}>Opret Email</button>
                                </div>
                        </Modal>
	                    
	            </div>

	        </div>
	    )
	}
}



export default withAuth(ManageAdmins);


// WEBPACK FOOTER //
// ./src/modules/admin/organization/ManageAdmins.js